import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Menu, Title, Item, SubMenuItem } from './styles'
import Cross from 'assets/svg/cross.svg'

const MainNav = ({
  popUpRef,
  open,
  setOpen
}) => {

  const history = useHistory()
  const { pathname } = useLocation()

  const MENU_ITEMS = [
    {
      title: 'HOME',
      to: '/floor/8',
    },
    {
      title: 'PARKING',
      to: '/parking',
    },
    {
      title: 'BOOKINGS',
      to: '/bookings',
      subMenu: [
        {
          title: 'Create Booking',
          to: '/create-booking',
        },
      ],
    },
    {
      title: 'STAFF',
      to: '/staff',
    },
    {
      title: 'REPORTS',
      to: '/reports',
      subMenu: [
        {
          title: 'Occupancy Report',
          to: '/reports/occupancy',
        },
        {
          title: 'Revenue Report',
          to: '/reports/revenue',
        },
        {
          title: 'Daily Reconciliation',
          to: '/reports/daily-reconciliation',
        },
        {
          title: 'Bookings Report',
          to: '/reports/bookings',
        },
        {
          title: 'Price Table',
          to: '/reports/price-table',
        },
      ],
    }
  ];

  return (
    <Menu
      open={open}
      ref={popUpRef}
    >
      <Title>
        <img
          src={Cross}
          alt="cross"
          onClick={()=>{
            setOpen(false)
          }}
        />
      </Title>
      {
        MENU_ITEMS.map((item, index) => {
          const { title, to, subMenu } = item
          return (
            <React.Fragment key={index}>
              {
                <>
                  <Item
                    desktop={title === 'HOME'}
                    active={to === pathname}
                    href={`https://pms.rookhotel.com${to}`}            
                    rel='noopener noreferrer'
                    onClick={(event) => {
                      // Handle special key combinations (Ctrl/Cmd+click)
                      if (event.metaKey || event.ctrlKey) {
                        // Allow default behavior (opens in new tab)
                        return;
                      }
                      
                      // Prevent default anchor behavior (full page reload)
                      event.preventDefault();
                      
                      // Perform client-side navigation
                      history.push(to);
                    }}
                  >
                    {title}
                  </Item>
                  {
                    subMenu?.map(({ title, to }, i) => (
                      <SubMenuItem
                        key={i}
                        active={to === pathname}
                        href={`https://pms.rookhotel.com${to}`}            
                        rel='noopener noreferrer'
                        onClick={(event) => {
                          // Handle special key combinations (Ctrl/Cmd+click)
                          if (event.metaKey || event.ctrlKey) {
                            // Allow default behavior (opens in new tab)
                            return;
                          }
                          
                          // Prevent default anchor behavior (full page reload)
                          event.preventDefault();
                          
                          // Perform client-side navigation
                          history.push(to);
                          setOpen(false)
                        }}
                      >
                        {title}
                      </SubMenuItem>
                    ))
                  }
                </>
              }
            </React.Fragment>
          )
        })
      }
    </Menu>
  );
}

export default MainNav;
